/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Calendar_UpcomingInputs */

const en_seller_calendar_upcoming = /** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming Bookings`)
};

const es_seller_calendar_upcoming = /** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximas Reservas`)
};

const fr_seller_calendar_upcoming = /** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservations à venir`)
};

const de_seller_calendar_upcoming = /** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anstehende Buchungen`)
};

const id_seller_calendar_upcoming = /** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan Mendatang`)
};

/** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */
const ja_seller_calendar_upcoming = en_seller_calendar_upcoming;

/** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */
const zh_seller_calendar_upcoming = en_seller_calendar_upcoming;

/** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */
const ar_seller_calendar_upcoming = en_seller_calendar_upcoming;

/** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */
const it_seller_calendar_upcoming = en_seller_calendar_upcoming;

/** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */
const ru_seller_calendar_upcoming = en_seller_calendar_upcoming;

/** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */
const pt_seller_calendar_upcoming = en_seller_calendar_upcoming;

/** @type {(inputs: Seller_Calendar_UpcomingInputs) => LocalizedString} */
const ko_seller_calendar_upcoming = en_seller_calendar_upcoming;

/**
* | output |
* | --- |
* | "Upcoming Bookings" |
*
* @param {Seller_Calendar_UpcomingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_calendar_upcoming = /** @type {((inputs?: Seller_Calendar_UpcomingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Calendar_UpcomingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_calendar_upcoming(inputs)
	if (locale === "es") return es_seller_calendar_upcoming(inputs)
	if (locale === "fr") return fr_seller_calendar_upcoming(inputs)
	if (locale === "de") return de_seller_calendar_upcoming(inputs)
	if (locale === "ja") return ja_seller_calendar_upcoming(inputs)
	if (locale === "zh") return zh_seller_calendar_upcoming(inputs)
	if (locale === "ar") return ar_seller_calendar_upcoming(inputs)
	if (locale === "id") return id_seller_calendar_upcoming(inputs)
	if (locale === "it") return it_seller_calendar_upcoming(inputs)
	if (locale === "ru") return ru_seller_calendar_upcoming(inputs)
	if (locale === "pt") return pt_seller_calendar_upcoming(inputs)
	return ko_seller_calendar_upcoming(inputs)
});